const TRANSLATE = {
  'permissions.list.title': 'Listagem',
  'permissions.list.description': 'Pode ver a listagem',
  'permissions.create.title': 'Criação',
  'permissions.create.description': 'Pode criar um(a) novo(a)',
  'permissions.edit.title': 'Edição',
  'permissions.edit.description': 'Pode editar um(a) existente',
  'permissions.delete.title': 'Remoção',
  'permissions.delete.description': 'Pode remover um(a) novo(a)',
  'permissions.import.title': 'Importação',
  'permissions.import.description': 'Pode fazer uma importação por excel',
  'permissions.canEditServiceOrderImport.title': 'Edição por importação',
  'permissions.canEditServiceOrderImport.description': 'Pode realizar edições por importação',
  'permissions.export.title': 'Exportação',
  'permissions.export.description': 'Pode fazer uma exportação em excel',
  'permissions.setup.title': 'Configurações gerais',
  'permissions.setup.description': 'Pode alterar campos adicionais, levels, etc.',
  'permissions.seeDashboard.title': 'Visualização do Dashboard',
  'permissions.seeDashboard.description': 'Pode ver os gráficos do dashboard',
  'permissions.seeComplianceDashboard.title': 'Visualização de conformidade',
  'permissions.seeComplianceDashboard.description': 'Pode ver os gráficos de conformidade do dashboard',
  'permissions.seeMap.title': 'Visualização do mapa',
  'permissions.map.description': 'Visualização do mapa dos usuários',
  'permissions.createTemplateRecord.title': 'Geração documentos',
  'permissions.createTemplateRecord.description': 'Pode gerar documentos DOCX',
  'permissions.createServiceOrderForOthers.title': 'Criação de atividades para outros usuários',
  'permissions.createServiceOrderForOthers.description': '**Exclusivo para app mobile**',
  'permissions.useFastServiceOrder.title': 'Criação de atividades rápidas',
  'permissions.useFastServiceOrder.description':
    '**Exclusivo para app mobile**. Ao criar atividades no mobile, pula diretamente para execução.',
  'permissions.createLeanServiceOrder.title': 'Criação de atividades enxutas',
  'permissions.createLeanServiceOrder.description':
    '**Exclusivo para web**. Habilita um formulário mais enxuto de criação de atividades preenchendo o usuário e local automáticamente.',
  'permissions.hideSaveOnLeanServiceOrder.title': 'Permitir apenas "Salvar e executar" na criação enxuta',
  'permissions.hideSaveOnLeanServiceOrder.description':
    '**Exclusivo para web**. Quando ativada, oculta o botão "Salvar" na criação enxuta e deixa apenas "Salvar e executar", evitando registrar atividades sem executá-las. Desativada (padrão): exibe os dois botões.',
  'permissions.createChild.title': 'Criação de atividades filhas no app',
  'permissions.createChild.description':
    'Permite a criação de atividades filhas no app, sempre que uma atividade é concluída',
  'permissions.updateChecklistChildServiceOrder.title': 'Permite alterar o questionário de atividades filhas no app',
  'permissions.updateChecklistChildServiceOrder.description':
    'Permite alterar o questionário de atividades filhas no app, sempre que uma atividade filha está sendo gerada',
  'permissions.hideCheckinAndCheckout.title': 'Deve esconder a informação de checkin e checkout',
  'permissions.hideCheckinAndCheckout.description': 'Esconde o checkin e o checkout no resumo e PDF da atividade',
  'permissions.hideAttendanceTime.title': 'Deve esconder a informação de tempo de atendimento',
  'permissions.hideAttendanceTime.description': 'Esconde o tempo de atendimento no resumo e PDF da atividade',
  'permissions.canExecuteFromWeb.title': 'Pode executar atividades a partir da web',
  'permissions.canExecuteFromWeb.description': 'Permite que o usuário execute atividades na versão web da Btime',
  'permissions.canEditFinishedServiceOrders.title': 'Pode editar atividades finalizadas',
  'permissions.canEditFinishedServiceOrders.description':
    'Permite que o usuário que já tem permissão de edição, possa editar também atividades já finalizadas',

  'permissions.bulkCreateServiceOrders.title': 'Criação de atividades em massa',
  'permissions.bulkCreateServiceOrders.description':
    '**Exclusivo do app mobile** Permite criar várias atividades de uma vez.',

  'permissions.createServiceOrderWithoutUser.title': 'Permitir criar atividade sem usuário',
  'permissions.createServiceOrderWithoutUser.description':
    '**Exclusivo para app mobile**. Se ativada: o campo de usuário fica oculto. Se desativada: o campo é obrigatório.',

  'permissions.useBtimeAI.title': 'Acesso ao Btime AI',
  'permissions.useBtimeAI.description': 'Permite acessar o Btime AI para obter insights e respostas sobre a operação',

  'permissions.refuseServiceOrder.title': 'Recusar atividades',
  'permissions.refuseServiceOrder.description':
    '**Exclusivo para app mobile**. Pode se recusar a executar uma atividade.',

  'permissions.canCreateSlaToServiceOrder.title': 'Criar SLA para atividades',
  'permissions.canCreateSlaToServiceOrder.description': 'Permite criar SLA para atividades',

  'permissions.hideServiceOrdersPlace.title': 'Salvar atividades sem local',
  'permissions.hideServiceOrdersPlace.description': 'Permite salvar atividades sem local',

  'permissions.reviewServiceOrder.title': 'Recuperação de respostas',
  'permissions.reviewServiceOrder.description': 'Permite recuperar as respostas da última atividade',

  'permissions.setupServiceOrderTag.title': 'Tag de Atividade',
  'permissions.setupServiceOrderTag.description': 'Pode criar, editar e remover tags de atividade',

  'permissions.editServiceOrdersName.title': 'Editar nome da atividade',
  'permissions.editServiceOrdersName.description': 'Criar e editar atividades com nome',

  'permissions.editServiceOrdersStatus.title': 'Gerenciamento de status',
  'permissions.editServiceOrdersStatus.description': 'Permite aprovar, cancelar e reprovar',

  'permissions.executePublicServiceOrder.title': 'Envio de atividade pública',
  'permissions.executePublicServiceOrder.description':
    'Permite envio por email para execução de atividades por links públicos',

  'permissions.seeOnlySelfServiceOrders.title': 'Visualizar somente as próprias atividades',
  'permissions.seeOnlySelfServiceOrders.description': 'Usuário só vai poder visualizar atividades próprias',

  'permissions.validateDuplicateServiceOrders.title': 'Validação de atividades duplicadas',
  'permissions.validateDuplicateServiceOrders.description':
    'Ao criar atividades em massa, será verificado se já existem atividades semelhantes',

  'permissions.seeServiceOrdersResume.title': 'Visualização do resumo',
  'permissions.seeServiceOrdersResume.description': 'Usuário consegue visualizar o resumo da atividade',

  'permissions.seeServiceOrdersPublicResumeLink.title': 'Visualização do link público',
  'permissions.seeServiceOrdersPublicResumeLink.description':
    'Usuário consegue visualizar e copiar o link do resumo público',

  'permissions.useResumePdfHeaderImage.title': 'Imagem de cabeçalho no PDF de resumo',
  'permissions.useResumePdfHeaderImage.description':
    'Permite adicionar ou remover uma imagem de cabeçalho no PDF de resumo',

  'permissions.useAutomaticDistribution.title': 'Distribuição automática de atividade',
  'permissions.useAutomaticDistribution.description': 'Permite utilizar a distribuição automática de atividades',

  'permissions.requirePauseReason.title': 'Tornar motivo de pausa como obrigatório',
  'permissions.requirePauseReason.description': 'Exige um motivo para pausa toda vez que uma atividade for pausada.',

  'permissions.createLocationsPlaceLevel.title': 'Permite criar niveis de locais',
  'permissions.createLocationsPlaceLevel.description': 'Permite criar place levels',

  'permissions.seeRecordIds.title': 'Permite ver os ids dos registros',
  'permissions.seeRecordIds.description': 'Permite ver os ids dos registros pelo front',

  'permissions.canViewLabelTriggersCall.title': 'Permite ver tags de erro dos gatilhos em atividades',
  'permissions.canViewLabelTriggersCall.description': 'Permite ver tags de erro dos gatilhos em atividades',

  'permissions.canViewServiceOrderInternalId.title': 'Exibir #id interno em atividades',
  'permissions.canViewServiceOrderInternalId.description':
    'Exibe o id interno do registro (#id) acima do código anual da atividade em cards, modais e tabelas.',

  'permissions.seeServiceOrdersTimeline.title': 'Visualização da linha do tempo',
  'permissions.seeServiceOrdersTimeline.description':
    'Permite visualizar a aba de linha do tempo nos detalhes da atividade.',

  'permissions.seeServiceOrdersTriggerEvents.title': 'Visualização dos eventos de gatilho',
  'permissions.seeServiceOrdersTriggerEvents.description':
    'Permite visualizar a aba de eventos de gatilho (atalhos) nos detalhes da atividade.',

  'permissions.seeServiceOrdersAuditPanel.title': 'Visualização do painel de auditoria',
  'permissions.seeServiceOrdersAuditPanel.description':
    'Permite visualizar a aba de auditoria nos detalhes da atividade.',

  'permissions.useNumberedPagination.title': 'Usa paginações numeradas',
  'permissions.useNumberedPagination.description':
    'Desativa scroll infinito e navega pelas paginas das tabelas pela navegação',

  'permissions.editFinishedServiceOrdersUser.title': 'Edita usuário de atividades concluídas',
  'permissions.editFinishedServiceOrdersUser.description':
    'Permite alterar usuário mesmo de atividades que já foram concluídas ou discontinuadas',

  'permissions.setupScreen.title': 'Gerenciar visões de telas',
  'permissions.setupScreen.description': 'Permite criar, editar e remover visões de telas como kanban',

  'permissions.showExpiredContractWarning.title': 'Exibir alerta de contrato expirado',
  'permissions.showExpiredContractWarning.description':
    'Exibe um alerta em todas as listagens, dashboard e mapa sobre pendência de contrato.',

  'permissions.showBillingWarning.title': 'Exibir alerta de fatura em aberto',
  'permissions.showBillingWarning.description':
    'Exibe um alerta em todas as listagens, dashboard e mapa sobre a existência de fatura em aberto.',

  'permissions.showQRCodeOnModalDetails.title': 'Exibir aba de QR Codes em Locais e Ativos',
  'permissions.showQRCodeOnModalDetails.description':
    'Permite a exibição da aba de QR Codes no modal de detalhes de Locais e Ativos.',

  'permissions.blockPastDates.title': 'Impedir a seleção de datas passadas',
  'permissions.blockPastDates.description': 'Impede a seleção de datas anteriores ao dia atual.',

  'permissions.setupDashboard.title': 'Gerenciar telas de dashboard',
  'permissions.setupDashboard.description': 'Permite criar, editar e remover visões de telas do dashboard',

  'permissions.createUserGroup.title': 'Criação de grupos',
  'permissions.createUserGroup.description': 'Pode criar novos grupos de usuário',

  'permissions.requireUserGroup.title': 'Grupo obrigatório',
  'permissions.requireUserGroup.description': 'Todo usuário deve fazer parte de um grupo',

  'permissions.changePassword.title': 'Alterar senha',
  'permissions.changePassword.description': 'Pode alterar senha dos usuários',

  'permissions.createChecklistType.title': 'Criação de tipos',
  'permissions.createChecklistType.description': 'Pode criar novos tipos de questionário',

  'permissions.requireChecklistType.title': 'Tipo obrigatório',
  'permissions.requireChecklistType.description': 'Todo checklist deve ter um tipo',

  'permissions.showUndoOption.title': 'Desfazer',
  'permissions.showUndoOption.description':
    'Habilita a opção de desfazer as últimas alterações durante a criação de um questionário',

  'permissions.createXsPlaceLevel.title': 'Permite criar niveis de locais',
  'permissions.createXsPlaceLevel.description': 'Permite criar place levels',

  'permissions.seeConfidentialFields.title': 'Permite visualizar campos confidenciais',
  'permissions.seeConfidentialFields.description': 'Permite visualizar campos adicionais confidenciais',

  'permissions.completeNonCompliance.title': 'Concluir não conformidade',
  'permissions.completeNonCompliance.description': 'Pode concluir não conformidades manualmente',
  'permissions.reopenNonCompliance.title': 'Reabrir não conformidade',
  'permissions.reopenNonCompliance.description': 'Pode reabrir não conformidades manualmente',

  'permissions.useAvailabilityPanel.title': 'Usar Painel de Disponibilidade',
  'permissions.useAvailabilityPanel.description':
    'Habilita o menu e o painel de Disponibilidade dos Locais no lugar do fluxo de Não Conformidades.',
  'permissions.editPlaceAvailabilityStatus.title': 'Permitir alterar status do local manualmente',
  'permissions.editPlaceAvailabilityStatus.description':
    'Habilita o botão de alteração manual do status de disponibilidade na lista, no kanban e nos detalhes do local, incluindo o arrastar de cartões entre colunas.',
  'permissions.notificationAlert.title': 'Habilitar alerta de notificação',
  'permissions.notificationAlert.description': 'Emite uma notificação quando há uma nova atividade.',
  'permissions.switchChecklistNameByYearlyId.title': 'Trocar o nome do questionário pelo id da atividade',
  'permissions.switchChecklistNameByYearlyId.description':
    'Exibe o id da atividade no lugar do nome do checklist no resumo e no PDF',

  'permissions.removeGeneralStock.title': 'Ajuste Manual do Estoque Geral',
  'permissions.removeGeneralStock.description': 'Ajuste manual de quantidade e valor.',

  'permissions.canUseDateKanbanSuggestion.title': 'Sugestão de datas no kanban',
  'permissions.canUseDateKanbanSuggestion.description':
    'Sugestão de datas de abertura, agendamento e conclusão no Kanban',

  'permissions.canUseTwilioIntegration.title': 'Twilio',
  'permissions.canUseTwilioIntegration.description': 'Permite acessar e configurar a integração com o Twilio',

  'permissions.enablePlaceLock.title': 'Bloqueio de locais',
  'permissions.enablePlaceLock.description': 'Habilita o bloqueio de locais ao criar atividade.',

  'permissions.requireUnproductiveServiceOrderSignature.title': 'Assinatura para Atividade Improdutiva',
  'permissions.requireUnproductiveServiceOrderSignature.description':
    'Exige assinatura ao mudar uma atividade para improdutiva.',

  'permissions.validateDuplicateServiceOrdersOnApp.title': 'Habilitar alerta de duplicidade no App',
  'permissions.validateDuplicateServiceOrdersOnApp.description':
    'Exibe um alerta no app ao tentar criar uma atividade duplicada.',

  'permissions.configureAssetQrCodeMenuRules.title': 'Configurar regras de menu de QR Code de Ativo por tipo e local',
  'permissions.configureAssetQrCodeMenuRules.description':
    'Permite configurar o menu do QR Code de Ativo por tipo de ativo e local, permitindo múltiplas regras combinadas em vez de um único menu para todos os ativos.',

  'modules.general.title': 'Configurações gerais',
  'modules.assets.title': 'Ativos',
  'modules.dynamicServiceOrders.title': 'Atividades Dinâmicas',
  'modules.stocks.title': 'Estoque',
  'modules.masks.title': 'Máscaras',
  'modules.templates.title': 'Templates de documentos',
  'modules.refunds.title': 'Reembolsos',
  'modules.dashboard.title': 'Dashboard',
  'modules.users.title': 'Usuários',
  'modules.checklists.title': 'Questionários',
  'modules.serviceOrders.title': 'Atividades',
  'modules.maps.title': 'Mapa',
  'modules.fleets.title': 'Frotas',
  'modules.triggers.title': 'Automações',
  'modules.routines.title': 'Rotinas',
  'modules.segments.title': 'Segmentações',
  'modules.locations.title': 'Locais',
  'modules.people.title': 'Pessoas',
  'modules.forms.title': 'Formulários',
  'modules.qrcode.title': 'QR Codes',
  'modules.nonCompliances.title': 'Não conformidades',
  'modules.availability.title': 'Disponibilidade dos Locais',
  'modules.availability.description': 'Painel de disponibilidade dos locais',
  'modules.integrations.title': 'Integrações',
  'modules.qrcode.description': 'Gerenciamento de QR Codes',
  'modules.nonCompliances.description': 'Visualizar todas as não conformidades',
  'modules.publicToken.title': 'Páginas e apis públicas',
  'modules.publicToken.description': 'Visualizar token público',
  'modules.router.description': 'Roteirização',

  title: 'Permissões',
  all: 'Todos',
  enable: 'Ativar',
  disable: 'Desativar',
  errorUpdatingPermission: 'Ocorreu um erro ao atualizar a permissão'
}

export default TRANSLATE
